import { useEffect } from "react";
import { useAppSelector } from "../../../../hooks/app";
import { AppAvatar, AppBox, AppButton, AppPaper, AppSkeletonHeader, AppTitle } from "../../../../commons/components";
import { StatusEnum } from "../../../../commons/enums/status-enum";
import setDocumentTitle from "../../../../commons/utilities/document-title";
import { toTitleCase } from "../../../../commons/utilities/string-utils";
import { Can } from "../../../../casl/Can";
import { RolePolicyActionEnum } from "../../../../commons/enums/role-policy-action.enum";
import { IFootballOrganizer } from "../../../../commons/models/football/interface/i-football-organizer";
import { FootballOrganizer } from "../../../../commons/models/football/football-organizer";

interface FootballOrganizerManageDetailHeaderProps {
  footballOrganizer: IFootballOrganizer;
  onEditFootballOrganizer?: (event?: Event) => void;
}

export default function FootballOrganizerManageDetailHeader({
  footballOrganizer,
  onEditFootballOrganizer,
}: FootballOrganizerManageDetailHeaderProps) {
  const { footballOrganizerInfoStatus } = useAppSelector((state) => state.manageFootballOrganizer);
  useEffect(() => {
    setDocumentTitle([`${toTitleCase(footballOrganizer.name)}`, "Manage"]);
  }, [footballOrganizer]);
  return (
    <AppPaper shadow="xs" padding="none">
      {footballOrganizerInfoStatus === StatusEnum.Loading ? (
        <AppSkeletonHeader withoutBackground />
      ) : (
        <AppBox alignItems="center" justifyContent="space-between" p="sm" gap="xs">
          <AppBox alignItems="center" gap="xs">
            <AppAvatar username={footballOrganizer.name} size="2xl" src={footballOrganizer.logo || ""} />
            <AppBox flexDirection="column" gap="3xs">
              <AppTitle as="h4">{toTitleCase(footballOrganizer.name)}</AppTitle>
            </AppBox>
          </AppBox>
          <Can I={RolePolicyActionEnum.UPDATE} a={FootballOrganizer}>
            <AppButton variant="light" label="Edit Organizer Info" onClick={onEditFootballOrganizer} />
          </Can>
        </AppBox>
      )}
    </AppPaper>
  );
}
